<template>
  <div class="weekly-history">
    <div v-if="loading" class="wh-card text-center">
      <b-spinner small /> Loading…
    </div>

    <b-alert v-else-if="error" show variant="danger">
      {{ error }}
      <a href="#" class="alert-link ml-1" @click.prevent="load">Try again</a>
    </b-alert>

    <div v-else-if="!sheets.length" class="wh-card" data-test="empty">
      No submitted timesheets yet.
    </div>

    <div v-else class="wh-card p-0">
      <button
        v-for="s in sheets"
        :key="s.id"
        type="button"
        class="wh-row"
        :data-test="`sheet-${s.id}`"
        @click="open(s)"
      >
        <span>
          <strong>{{ s.project_name }}</strong>
          <span class="d-block text-muted small">
            Week of {{ formatDate(s.week_start) }}
          </span>
        </span>
        <b-badge :variant="variant(s)" class="wh-badge">{{ label(s) }}</b-badge>
      </button>
    </div>

    <weekly-sheet-detail-modal
      :sheet-id="openId"
      @amend="onDetailAmend"
      @changed="load"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import WeeklySheetDetailModal from '@/components/timesheets/weekly/WeeklySheetDetailModal.vue'
import { weeklyStatusLabel, weeklyStatusVariant } from '@/utils/myWeekSheet'

// The app's History & Status list: every week the tradie has filled in or
// sent. A draft opens straight in Submit (it only has hours to finish); any
// other week opens its status and history.
export default {
  components: { WeeklySheetDetailModal },

  data() {
    return { sheets: [], loading: true, error: null, openId: null }
  },

  created() {
    this.load()
  },

  methods: {
    formatDate(date) {
      return dayjs(date).format('D MMM YYYY')
    },

    label(s) {
      return weeklyStatusLabel(s)
    },

    variant(s) {
      return weeklyStatusVariant(this.label(s))
    },

    async load() {
      this.loading = true
      this.error = null
      try {
        this.sheets = await this.$store.dispatch('timesheet/myWeekHistory')
      } catch (e) {
        this.error =
          (e && e.response && e.response.data && e.response.data.message) ||
          'Could not load your timesheets.'
      } finally {
        this.loading = false
      }
    },

    open(s) {
      if (s.status === 'draft' && !s.finalised_at) {
        this.$emit('amend', {
          projectId: s.project_id,
          weekStart: s.week_start,
        })
        return
      }
      this.openId = s.id
      this.$nextTick(() => this.$bvModal.show('weekly-sheet-detail-modal'))
    },

    onDetailAmend(sheet) {
      this.$emit('amend', {
        projectId: sheet.project_id,
        weekStart: sheet.week_start,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wh-card {
  background: #fff;
  border: 1px solid #e4e7eb;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  overflow: hidden;
}
.wh-row {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: none;
  border: 0;
  border-bottom: 1px solid #f0f2f4;
  text-align: left;
}
.wh-row:last-child {
  border-bottom: 0;
}
.wh-row:hover {
  background: #f8f9fb;
}
.wh-badge {
  white-space: normal;
  text-align: right;
}
</style>
